import React from 'react';
import Select from 'react-select';

type Props = {
  tags;
  tagOptions;
  handleChange;
};

function SalesforceUserTagsFilter({ tags, tagOptions, handleChange }: Props) {
  return (
    <Select
      className="property mr-2"
      placeholder="Filter by Tag"
      options={tagOptions}
      onChange={handleChange}
      value={tags}
      isMulti
    />
  );
}

export default SalesforceUserTagsFilter;
